import "@/styles/components/styled-form.css";

export const setupDropdowns = async (form) => {
  const dropdowns = form.querySelectorAll(".js-dropdown, .userform .field.dropdown");

  if (!dropdowns.length) {
    return;
  }

  const { default: easydropdown } = await import("easydropdown-a11y");
  import("@/styles/components/dropdown.css");

  dropdowns.forEach((el) => {
    const select = el.querySelector("select");

    if (!select) {
      return;
    }

    if (select.closest(".edd-root")) {
      return;
    }

    const placeholder = el.querySelector('option[value=""]');

    if (placeholder && !placeholder.hasAttribute("data-placeholder")) {
      placeholder.setAttribute("data-placeholder", true);

      if (!placeholder.textContent) {
        placeholder.textContent = "Select One";
      }
    }

    const opts = {
      behavior: {
        openOnFocus: true,
        maxVisibleItems: 8,
        liveUpdates: true,
        useNativeUiOnMobile: false,
      },
    };

    easydropdown(select, opts);
  });
};

const setupMasks = async (form) => {
  const fields = form.querySelectorAll('input[type="tel"], input[data-mask-currency], input[data-mask-num-range]');

  if (!fields.length) {
    return;
  }

  const { default: IMask } = await import("imask/esm/imask");
  await import("imask/esm/masked/number");
  await import("imask/esm/masked/pattern");

  fields.forEach((field) => {
    if (field.type === "tel") {
      IMask(field, {
        mask: "(000) 000-0000",
      });
    }

    if (field.dataset.maskCurrency !== undefined) {
      const mask = IMask(field, {
        mask: Number,
        scale: 0,
        thousandsSeparator: ",",
        min: 1,
      });

      field.addEventListener("updateValue", (e) => {
        field.value = e.detail;
        mask.updateValue();
        field.dispatchEvent(new Event("blur"));
      });
    }

    if (field.dataset.maskNumRange !== undefined) {
      const mask = IMask(field, {
        mask: /^(\d+)?(-)?(\d+)?$/,
      });

      field.addEventListener("updateValue", (e) => {
        field.value = e.detail;
        mask.updateValue();
        field.dispatchEvent(new Event("blur"));
      });
    }
  });
};

const setupSpecialFields = (form) => {
  form.querySelectorAll("input[type=file]").forEach((input) => {
    const placeholder = document.createElement("div");
    placeholder.classList.add("file-input-placeholder");

    if (input.value) {
      placeholder.textContent = input.files[0].name;
    } else {
      placeholder.textContent = input.dataset.placeholder;
    }

    input.parentNode.insertBefore(placeholder, input);

    placeholder.addEventListener("click", () => input.click());

    input.addEventListener("change", (e) => {
      placeholder.textContent = e.target.files[0].name;
      placeholder.classList.add("filled");
    });
  });

  form.querySelectorAll(".form-field-wrapper.has-length-limit").forEach((field) => {
    const input = field.querySelector(".has-length-limit");

    if (input && input.maxLength) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("length-limit-wrapper");
      input.parentNode.insertBefore(wrapper, input);
      wrapper.appendChild(input);

      const counter = document.createElement("div");
      counter.classList.add("length-limit-counter");

      const count = document.createElement("span");
      const remaining = input.maxLength - input.value.length;

      count.textContent = `${remaining}/${input.maxLength}`;
      counter.appendChild(count);

      wrapper.appendChild(counter);

      input.addEventListener("keyup", (e) => {
        const input = e.target.closest(".has-length-limit");
        const field = input.closest(".field.has-length-limit");

        if (input && field) {
          const count = field.querySelector(".length-limit-counter span");
          const remaining = input.maxLength - input.value.length;
          count.textContent = `${remaining}/${input.maxLength}`;
        }
      });
    }
  });
};

export const setupStyledForm = (form) => {
  setupDropdowns(form);
  setupMasks(form);
  setupSpecialFields(form);
};
